/**
 * The time now, kept moving for whatever on the page shows an age ("last write 40 s ago").
 *
 * ONE timer for the whole page, however many things read it: every row of a running scrape
 * asks here, and only those rows are drawn again when it ticks. The timer starts with the first
 * reader and stops with the last, so a page with nothing running has no timer at all.
 */
import { useSyncExternalStore } from "react";

export const TICK_MS = 10 * 1000;

let now = Date.now();
let timer = null;
const readers = new Set();

const tick = () => { now = Date.now(); for (const reader of readers) reader(); };

function subscribe(reader) {
  readers.add(reader);
  if (timer === null) { now = Date.now(); timer = setInterval(tick, TICK_MS); }
  return () => {
    readers.delete(reader);
    if (readers.size === 0 && timer !== null) { clearInterval(timer); timer = null; }
  };
}
const read = () => now;

// A reader that is not enabled asks for no timer and gets ONE fixed time: a value that changed on every draw would
// have React draw it again for ever.
const notMoving = Date.now();
const noSubscription = () => () => {};
const readNotMoving = () => notMoving;

/**
 * @param {boolean} enabled false: no timer is asked for (the time given is then not to be used for an age)
 * @returns {number} milliseconds; moves about every ten seconds while enabled
 */
export function useTicker(enabled = true) {
  return useSyncExternalStore(enabled ? subscribe : noSubscription, enabled ? read : readNotMoving);
}

/** For tests: how many are reading, and whether a timer is running. */
export const tickerState = () => ({ readers: readers.size, running: timer !== null });
